export enum ProductDataStatus {
  MissingData = "Missing data",
  Filled = "Filled",
}
